import React from "react";
import PropTypes from "prop-types";
const ExitIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M-5-4h24v24H-5z" />
      <g fill={color || "var(--color-easil-gray-x-dark)"}>
        <path d="M2 2v12h5a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H2z" />
        <path d="M12.19 9.015l-.841.842a.989.989 0 0 0 0 1.399l.16.16a.989.989 0 0 0 1.398 0l2.4-2.4a.995.995 0 0 0 .112-.135.938.938 0 0 0 .132-1.436l-3.12-3.12a.938.938 0 1 0-1.327 1.325l1.162 1.162H6.489a.989.989 0 0 0-.989.989v.226c0 .546.443.988.989.988h5.702z" />
      </g>
    </g>
  </svg>
);
ExitIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default ExitIcon;
